export default "__VITE_PUBLIC_ASSET__b23d9a9f__"